// TIP-589 — the capability token in prefilled-registration / agent-intake /
// verify-account (and similar) routes is the sole credential for that lead.
// App.js sent window.location.pathname + search straight to Google Analytics
// on mount, so opening a share link handed the token to a third party (GA)
// via the pageview's `dl` param. Replace the token with a template segment
// before anything reaches ReactGA.

// Routes where the token lives in the path itself.
const TOKEN_PATH_PREFIXES = [
  "/agent-intake/",
  "/company-registration/",
  "/verify-account/",
  "/update/trade-license/",
];

// Query params that carry a token/credential on any route (e.g.
const TOKEN_QUERY_PARAMS = ["token"];

const sanitizePathname = (pathname) => {
  const prefix = TOKEN_PATH_PREFIXES.find((p) => pathname?.startsWith(p));
  return prefix ? `${prefix}:token` : pathname;
};

const sanitizeSearch = (search) => {
  if (!search) return "";
  const params = new URLSearchParams(search);
  let redacted = false;
  TOKEN_QUERY_PARAMS.forEach((key) => {
    if (params.has(key)) {
      params.set(key, ":token");
      redacted = true;
    }
  });
  return redacted ? `?${params.toString()}` : search;
};

// Returns a GA-safe { page, title } pair — same shape App.js passes to
// ReactGA.send, with any credential token replaced by a fixed placeholder so
// aggregate page-view counts survive but the token itself never leaves the
// browser. `origin` is optional and only used to rebuild `title` (App.js
// previously sent the full href as the title).
export const sanitizeAnalyticsPage = (pathname, search, origin = "") => {
  const page = sanitizePathname(pathname) + sanitizeSearch(search);
  return { page, title: `${origin}${page}` };
};
